import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UIPreferencesState {
  useNewAlertSorting: boolean;
  setUseNewAlertSorting: (useNewAlertSorting: boolean) => void;
  viewNextAlertAutomatically: boolean;
  setViewNextAlertAutomatically: (viewNextAlertAutomatically: boolean) => void;
}

export const useUIPreferencesStore = create<UIPreferencesState>()(
  persist(
    (set) => ({
      useNewAlertSorting: false,
      setUseNewAlertSorting: (useNewAlertSorting) => {
        set({ useNewAlertSorting });

        try {
          setTimeout(() => {
            Object.keys(localStorage).forEach((key) => {
              if (key.startsWith('rq-alerts')) {
                localStorage.removeItem(key);
              }
            });

            Object.keys(localStorage).forEach((key) => {
              if (key.includes('alertsquery')) {
                localStorage.removeItem(key);
              }
            });

            window.location.reload();
          }, 0);
        } catch (e) {
          console.error('Failed to clear cache when changing alert sorting preference', e);
        }
      },
      viewNextAlertAutomatically: true,
      setViewNextAlertAutomatically: (viewNextAlertAutomatically) =>
        set({ viewNextAlertAutomatically }),
    }),
    {
      name: 'ui-preferences-storage',
    }
  )
);
